import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { isMobileOnly } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';

import Table from '../../../../components/LeagueTable';

import { leagueSetTeamInfo } from '../../../../redux/actions/League';
import { showMobileSidebarSection } from '../../../../redux/actions/Team';
import { showPopupWindow } from '../../../../redux/actions/Popups';
import { calendarData } from '../../../../redux/selector/League';

import { rankingTableColumns } from '../../../../service/data';
import { matchdayProgress } from '../../../../service/leagueTable';
import { POPUPS } from '../../../../service/constants';

import { StyledContainer, StyledMatchday, StyledTableContainer, StyledViewMore } from './styled';
import SectionHeading from '../../../../components/SectionHeading';
import { ReactComponent as ArrowUpRight } from '../../../../assets/img/arrow-up-right.svg';

export default function TableContainer({ ranking, leagueName }) {
  const { TEAM_INFO_POPUP } = POPUPS;
  const dispatch = useDispatch();
  const addInfoAboutTeam = (_data) => {
    dispatch(leagueSetTeamInfo(_data, isMobileOnly));
    if (isMobileOnly) {
      dispatch(showMobileSidebarSection('teamInfo'));
    } else {
      dispatch(showPopupWindow(TEAM_INFO_POPUP, TEAM_INFO_POPUP, true));
    }
  };

  const data = useMemo(
    () => ranking.map((rank, index) => ({ ...rank, number: index + 1 })),
    [ranking]
  );
  const fixtures = useSelector(calendarData);
  const matchdayLabel = useMemo(() => {
    const { current, total } = matchdayProgress(fixtures?.matches, {
      currentDate: fixtures?.currentDate,
      timezone: fixtures?.timezone,
    });
    if (current == null || total == null) return null;
    return `Matchday ${current} / ${total}`;
  }, [fixtures]);

  return (
    <StyledTableContainer>
      <SectionHeading
        title="League"
        info={matchdayLabel ? <StyledMatchday>{matchdayLabel}</StyledMatchday> : null}
        action={
          <StyledViewMore to="/league">
            View more
            <ArrowUpRight />
          </StyledViewMore>
        }
      />
      <StyledContainer className="rank-table">
        <Table
          canSelectPlayer
          getTeamInfo={addInfoAboutTeam}
          data={data}
          columns={rankingTableColumns}
          isTeamInCurrentLeague
          leagueName={leagueName}
        />
      </StyledContainer>
    </StyledTableContainer>
  );
}

TableContainer.propTypes = {
  ranking: PropTypes.array.isRequired,
  leagueName: PropTypes.string,
};

TableContainer.defaultProps = {
  leagueName: null,
};
